import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { BillingCycle } from '@app/resources/services';
export const billingCycleAdapter: EntityAdapter<BillingCycle> = createEntityAdapter<BillingCycle>({
  // sortComparer: (a, b) => b.BillingCycleId - a.BillingCycleId, // we only have one loyalty program. If we need multiple, add a comparator function
  selectId: (e) => e.BillingCycleId,
});

export const selectBillingCycleEntities = billingCycleAdapter.getSelectors().selectEntities;
